import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'

import { ToastProvider } from '@/components/ui/toast'
import { createQueryClient } from '@/lib/query'
import { createAppRouter } from '@/router'

import '@/styles.css'

const queryClient = createQueryClient()
const router = createAppRouter(queryClient)

const container = document.getElementById('root')
if (!container) throw new Error('Elemen #root tidak ditemukan di dokumen.')

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
